import {
  leadSourceCard,
  otherContactCard,
  propertyDetailsCard,
} from '../../shared';
import type { DefaultCoverSheetConfig, LocaleOverrides } from '../../types';
import {
  buyerCard,
  buyersAgentCard,
  commissionDetailsCard,
  importantDatesCard,
  leaseAgreementDatesCard,
  propertyBeingSoldCard,
  rentCard,
  sellerCard,
  sellersAgentCard,
  sellerTCCard,
} from './cards';

export const BaseTenantConfig = {
  version: '1',
  sections: {
    propertyInfo: {
      id: 'propertyInfo',
      header: 'Property Info',
      sidebarText: 'Property Info',
      cards: {
        propertyBeingSoldCard,
        importantDatesCard,
        leaseAgreementDatesCard,
        rentCard,
        commissionDetailsCard,
        leadSourceCard,
        propertyDetailsCard,
      },
    },
    buyerSideContacts: {
      id: 'buySideContacts',
      header: "Tenant's Contacts",
      sidebarText: 'Tenant Contacts',
      cards: {
        buyersAgentCard,
        buyerCard,
      },
    },
    sellerSideContacts: {
      id: 'sellerSideContacts',
      header: "Landlord's Contacts",
      sidebarText: 'Landlord Contacts',
      cards: {
        sellersAgentCard,
        sellerTCCard,
        sellerCard,
      },
    },
    additionalContacts: {
      id: 'additionalContacts',
      header: 'Additional Contacts',
      sidebarText: 'Additional Contacts',
      cards: {
        otherContactCard,
      },
    },
  },
} satisfies DefaultCoverSheetConfig;

export type TenantLocaleOverrides = LocaleOverrides<typeof BaseTenantConfig>;
